import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Home.css';
import ParallaxBasic from '../../components/page/parallaxBasic/ParallaxBasic.jsx';
import ParallaxSplit from '../../components/page/parallaxSplit/ParallaxSplit.jsx';
import GridBlocks from '../../components/page/gridBlocks/GridBlocks.jsx';
import CTA from '../../components/page/cta/CTA.jsx';
import Footer from '../../components/global/footer/Footer.jsx';
// import Fonz2 from './fonz2.png';

import GridBlocksData from './GridBlocksData.js';

// let Scroller = Scroll.scroller;

/**
 * @class Home
 * @namespace Architect\React\Views
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Home extends Component {

    /**
     * Default props
     *
     * @type {{ctaText: string, scrollOptions: {duration: number, delay: number, smooth: boolean}, gridBlocksData: *[], parallaxBasicClassNames: *, parallaxBasicSectionClassName: *, gridBlocksClassNames: *}}
     */
    static defaultProps = {
        ctaText: 'Have a Question?',
        scrollOptions: {
            duration: 1500,
            delay: 100,
            smooth: true
        },
        gridBlocksData: GridBlocksData,
        parallaxBasicClassNames: classNames('ParallaxBasic', 'Parallax__group'),
        parallaxBasicSectionClassName: classNames('ParallaxBasic', 'Parallax__group'),
        gridBlocksClassNames: classNames('GridBlocks'),

    };

    /**
     * Prop types
     *
     * @type {{ctaText: shim, gridBlocksData, scrollOptions: shim, parallaxBasicClassNames: shim, parallaxBasicSectionClassName: shim, gridBlocksClassNames: shim}}
     */
    static propTypes = {
        ctaText: PropTypes.string,
        gridBlocksData: PropTypes.arrayOf(PropTypes.object),
        scrollOptions: PropTypes.object,
        parallaxBasicClassNames: PropTypes.string,
        parallaxBasicSectionClassName: PropTypes.string,
        gridBlocksClassNames: PropTypes.string
    };

    /**
     * State
     *
     * @type {{contentLoaded: boolean}}
     */
    state = {
        contentLoaded: false
    };

    /**
     * Home Constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.getData = this.getData.bind(this);
        this.success = this.success.bind(this);
        this.error = this.error.bind(this);
    }

    /**
     * Component did mount
     */
    componentDidMount() {
        // const url = 'https://solero.com/wp-json/wp/v2/pages/116';
        // this.getData(url);
    }

    /**
     * Get data from CMS.
     *
     * @param url
     */
    getData(url) {
        fetch(url)
            .then(res => res.json())
            .then(
                response => this.success(response),
                error => this.error(error)
            )
    }

    /**
     * Success response from Wordpress CMS Rest API.
     *
     * @param response
     */
    success(response) {

        this.setState({
            contentLoaded: true
            // title: response.title.rendered,
            // description: response.acf.text_team_content
        });
    }

    /**
     * Error fetch data from CMS.
     *
     * @param error
     */
    error(error) {
        this.setState({
            contentLoaded: false,
            error
        });
    }

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {ctaText, gridBlocksClassNames, gridBlocksData, parallaxBasicClassNames, parallaxBasicSectionClassName, setHeaderClassNames} = this.props;

        return (

            <main className="Home Parallax">

                <ParallaxBasic parallaxBasicClassNames={parallaxBasicClassNames}
                               setHeaderClassNames={setHeaderClassNames}
                               sectionClassName={parallaxBasicSectionClassName}
                               showImage={true}/>


                <GridBlocks data={gridBlocksData}
                            gridBlocksClassNames={gridBlocksClassNames}/>

                <ParallaxSplit/>

                <CTA ctaText={ctaText}
                     link="/contact"/>

                <Footer/>
            </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/home/Home.jsx